export const TENANT_NAME = {
  MOFFITT: 'MOFFITT SERVICES',
};

export const TENANT_ID = {
  FUEL_PANDA: '1',
};

export const TENANT_SLUG = {
  SPRAGUE_ENERGY_LLC: 'SPR',
};
